import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/shared";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Pricing from "@/pages/Pricing";
import AdminLogin from "@/pages/admin/AdminLogin";

import RetailerLayout from "@/pages/retailer/RetailerLayout";
import RHome from "@/pages/retailer/Home";
import Marketplace from "@/pages/retailer/Marketplace";
import ProductDetail from "@/pages/retailer/ProductDetail";
import Cart from "@/pages/retailer/Cart";
import Checkout from "@/pages/retailer/Checkout";
import PaymentResult from "@/pages/retailer/PaymentResult";
import ROrders from "@/pages/retailer/Orders";
import ROrderDetail from "@/pages/retailer/OrderDetail";
import RInvoices from "@/pages/retailer/Invoices";
import RProfile from "@/pages/retailer/Profile";
import RSubscription from "@/pages/retailer/Subscription";

import MfgLayout from "@/pages/manufacturer/MfgLayout";
import MDashboard from "@/pages/manufacturer/Dashboard";
import MProducts from "@/pages/manufacturer/Products";
import MOrders from "@/pages/manufacturer/Orders";
import MSettlements from "@/pages/manufacturer/Settlements";
import MAnalytics from "@/pages/manufacturer/Analytics";
import MSubscription from "@/pages/manufacturer/Subscription";
import MProfile from "@/pages/manufacturer/CompanyProfile";
import MReturns from "@/pages/manufacturer/Returns";

import AdminLayout from "@/pages/admin/AdminLayout";
import AOverview from "@/pages/admin/Overview";
import AManufacturers from "@/pages/admin/Manufacturers";
import AIntegrations from "@/pages/admin/Integrations";
import ASubscriptions from "@/pages/admin/Subscriptions";
import ASalesRequests from "@/pages/admin/SalesRequests";
import ARecords from "@/pages/admin/Records";

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <Loader label="Loading VIPER OWL…" />;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/auth"} replace />;
  if (role && user.role !== role) {
    const home = { retailer: "/retailer", manufacturer: "/manufacturer", admin: "/admin" }[user.role] || "/";
    return <Navigate to={home} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/admin/login" element={<AdminLogin />} />

            <Route path="/retailer" element={<Guard role="retailer"><RetailerLayout /></Guard>}>
              <Route index element={<RHome />} />
              <Route path="marketplace" element={<Marketplace />} />
              <Route path="product/:id" element={<ProductDetail />} />
              <Route path="cart" element={<Cart />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="payment/:result" element={<PaymentResult />} />
              <Route path="orders" element={<ROrders />} />
              <Route path="orders/:id" element={<ROrderDetail />} />
              <Route path="invoices" element={<RInvoices />} />
              <Route path="subscription" element={<RSubscription />} />
              <Route path="profile" element={<RProfile />} />
            </Route>

            <Route path="/manufacturer" element={<Guard role="manufacturer"><MfgLayout /></Guard>}>
              <Route index element={<MDashboard />} />
              <Route path="products" element={<MProducts />} />
              <Route path="orders" element={<MOrders />} />
              <Route path="settlements" element={<MSettlements />} />
              <Route path="analytics" element={<MAnalytics />} />
              <Route path="subscription" element={<MSubscription />} />
              <Route path="returns" element={<MReturns />} />
              <Route path="profile" element={<MProfile />} />
            </Route>

            <Route path="/admin" element={<Guard role="admin"><AdminLayout /></Guard>}>
              <Route index element={<AOverview />} />
              <Route path="manufacturers" element={<AManufacturers />} />
              <Route path="subscriptions" element={<ASubscriptions />} />
              <Route path="sales" element={<ASalesRequests />} />
              <Route path="integrations" element={<AIntegrations />} />
              <Route path=":section" element={<ARecords />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
